module.exports = __webpack_public_path__ + "header-profile-skin-3.png?bf471ec3d4085883e061ca35006e86e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/patterns/header-profile-skin-3.png
// module id = 166
// module chunks = 0